import React from 'react';

const AuthBypassWatermark = () => (
  <div className="auth-bypass-watermark">
    <span>Authentication Bypassed - Training Mode Only</span>
  </div>
);

export default AuthBypassWatermark;
